/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { shapes } from '@greenville/framework';
import { useHistory } from 'react-router-dom';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactJson from 'react-json-view';
import axios from 'axios';
import styled from 'styled-components';
import { MathUtil } from '@aquila/core';
import utils from '../../../common/utils';
import env from '../../../common/env';
import * as constants from '../../../common/constants';
import Autocomplete from './Autocomplete';
import { loadExternalJS } from './FlowUtils';
import ReadContent from './ReadContent';
import getExecutionLogs from '../service/getExecutionLogs';
import LogsViewer from './LogsViewer';
import getLLMLogs from '../service/getLLMLogs';
import CopyToClipboardButton from './CopyToClipboardButton';
import TokenService from '../service/TokenService';
import GoDeeperPills from './goDeeperPills/GoDeeperPills';
import { CHUNK, DONE, JSON_TEXT, META_DATA, STREAMING, VIEW } from '../constants/AgenticTextConstants';
import TenantsModel from '../models/TenantsModel';

const productModelList = [
  { id: '1', title: 'ETEXT2_PXE' },
  { id: '2', title: 'RPLUS_EPUB' },
  { id: '3', title: 'ETEXT2_CITE' },
  { id: '4', title: 'ETEXT_EPUB_BRONTE' },
  { id: '5', title: 'ETEXT_BV_BRONTE' },
  { id: '6', title: 'EXTERNAL_ACTIVEHUB' },
  { id: '7', title: 'EXTERNAL_THUB' },
  { id: '8', title: 'RPLUS_PDF' },
  { id: '9', title: 'ET1_PDF' },
  { id: '10', title: 'ETEXT_PDF' },
  { id: '11', title: 'ETEXT1_PDF' },
  { id: '12', title: 'EXTERNAL_PVS' }
];

const GraphTester = ({ graphName, graphId, graphVersion, isOpen, onClose, bookList, tenantId, tenantState }) => {
  const history = useHistory();
  const [output, setOutput] = useState('');
  const [formData, setFormData] = useState({});
  const [fullResponse, setFullResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showFullResponse, setShowFullResponse] = useState(false);
  const [tokenValue, setTokenValue] = useState('');
  const [threadId, setThreadId] = useState('');
  const [logType, setLogType] = useState('');
  const [isStreamDone, setIsStreamDone] = useState(false);
  const [executionLogs, setExecutionLogs] = useState(null);
  const [simplifiedExecutionLogs, setSimplifiedExecutionLogs] = useState(null);
  const [llmLogs, setLLMLogs] = useState(null);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [showExecutionLogModal, setShowExecutionLogModal] = useState(false);
  const [showLLMLogModal, setShowLLMLogModal] = useState(false);
  const [logsLoading, setLogsLoading] = useState(false);
  const [goDeeperPills, setGoDeeperPills] = useState(null);
  const outputRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const dragOffset = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragOffset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const callCDNTokenAPI = async () => {
    const headers = {
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.get(`${env.EVERGREEN_API_BASE_URL}${constants.GET_CDN_TOKEN_URL}`, { headers });
    if (response && response.data && response.data.data) {
      const cdnTokenVal = response.data.data;
      utils.setCDNTokenInCookie(cdnTokenVal);
    }
  };

  useEffect(() => {
    const token = utils.getToken();
    setTokenValue(token);
    loadExternalJS();
    MathUtil.loadMathJax();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(tokenValue)) {
      callCDNTokenAPI();
    }
  }, [tokenValue]);
  /* eslint-disable */

  // Auto-scroll to bottom when displayText updates
  useEffect(() => {
    if (outputRef.current) {
      outputRef.current.scrollTo({
        top: outputRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [output]);

  useEffect(() => {
    return () => {
      setError(null);
      setOutput('');
      setFormData({});
      setFullResponse(null);
      setShowFullResponse(false);
      setIsStreamDone(false);
      setThreadId('');
      setPosition({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
      dragOffset.current = { x: 0, y: 0 };
      setCurrentRequestId(null);
    };
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setIsStreamDone(false);
    setOutput('');
    setFullResponse(null);

    const { input = '', bookId = '', productModel = '', pageId, imageObject } = formData;

    const payload = {
      input,
      bookId,
      indexId: bookId,
      productModel,
      ...(threadId ? { threadId } : {}),
      ...(pageId ? { pageIds: [pageId] } : {})
    };

    try {
      if (imageObject && typeof imageObject === 'string') {
        const formattedImageObject = JSON.parse(imageObject);
        const { contextUrl, contextId, contextType } = formattedImageObject;
        payload.additionalContext = [
          {
            contextUrl,
            contextId,
            contextType: contextType || 'image'
          }
        ];
      }
    } catch (err) {
      console.log('Image Copilot Input Error', err);
    }

    try {
      const sysTosysToken = await TokenService.getSys2sysToken();
      const response = await fetch(`${env.BERLIN_API_URI}/api/1.0/run-graph/${graphId}/versions/${graphVersion}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${sysTosysToken}`,
          'Content-Type': 'application/json',
          [constants.BERLIN_TENANT_ID_HEADER]: tenantId,
          ...(!threadId ? { 'New-Thread': true } : {}),
          useStream: 'true'
        },
        body: JSON.stringify(payload)
      });

      const reader = response.body.getReader();
      const requestId = response.headers.get('x-request-id');
      const tId = response.headers.get('x-thread-id');
      setThreadId(tId);
      setCurrentRequestId(requestId);
      let streamingContent = '';
      let intentType = '';

      const readStream = () => {
        reader
          .read()
          .then(({ done, value }) => {
            if (done) {
              setLoading(false);
              setIsStreamDone(true);
              intentType = '';
              return;
            }

            if (value) {
              const decodedData = new TextDecoder('utf-8').decode(value);
              const chunks = decodedData.split('\n\n');

              for (const rawChunk of chunks) {
                const trimmed = rawChunk.trim();
                if (!trimmed) continue;

                let payload;
                try {
                  const jsonLine = trimmed.startsWith('data: ') ? trimmed.slice(6) : trimmed;
                  payload = JSON.parse(jsonLine);
                } catch (e) {
                  console.warn('Skipped bad JSON:', rawChunk);
                  continue;
                }

                const { streamStatus, type, content, contentType } = payload;

                const isStreamingMetaDataIntentType =
                  streamStatus === STREAMING && type === META_DATA && content?.intentType;
                const isStreamingChunk = streamStatus === STREAMING && type === CHUNK;
                const isJSONStreamingContent = isStreamingChunk && contentType === JSON_TEXT;

                if (isStreamingMetaDataIntentType) {
                  intentType = content?.intentType;
                }
                if (isStreamingChunk && !contentType) {
                  streamingContent += content;
                  setFullResponse(streamingContent);
                  setOutput(streamingContent);
                }
                if (isJSONStreamingContent && intentType === VIEW) {
                  const goDeeperData = JSON.parse(content);
                  if (goDeeperData?.contents?.length) {
                    setGoDeeperPills(goDeeperData.contents);
                  }
                }
                if (streamStatus === DONE) {
                  intentType = '';
                }
              }
            }

            readStream();
          })
          .catch((err) => {
            console.error('Stream read error:', err);
            setError('Stream read failed');
            setLoading(false);
          });
      };

      readStream(); // ✅ Start reading the response stream
    } catch (err) {
      setError(err.message || 'Request failed');
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const launchTestBed = (e) => {
    const { bookId = '', productModel = '', pageId } = formData;
    const { selectedTenant } = toJS(tenantState);
    const inputData = {
      berlinEnv: env.BERLIN_ENV,
      tenantId: tenantId,
      tenantKey: selectedTenant.tenantKey,
      tenantName: selectedTenant.name,
      courseId: bookId || graphId,
      productModel: productModel,
      graphName: graphName,
      graphId: graphId,
      version: graphVersion,
      pageId: pageId,
      userId: '',
      message: '',
      tutorName: selectedTenant.title,
      botName: 'Berlin Bot',
      channelId: '',
      expandMode: false,
      enableProblemSolveFeature: true,
      showRecommendedPrompts: true,
      AIEnableHigherOrderSuggestion: true,
      AIEnableNewValidateAnswer: true,
      AIEnableQuizRandomization: true,
      AIEnableAIShowChannelVideos: true,
      AIEnableAgentic: true,
      enableExplainQuizOptions: '',
      showSummary: false,
      showPractice: false,
      showExplain: false,
      // Hidden Canned Messages configuration
      isWelcomeMessageFromTestBed: true,
      bookTitle: false,
      bookTitlePreText: false,
      bookTitleSubText: false,
      recommendationsHeading: false,
      ctaButtonHeadingWithRecommendationPills: false,
      ctaButtonHeadingWithOutRecommendationPills: false,
      newTopic: false
    };
    const stringifiedObject = JSON.stringify(inputData);
    const safeString = encodeURIComponent(stringifiedObject);
    const base64String = btoa(safeString);
    window.open(`/configure/${inputData.tenantName}/agentic?configs=${base64String}`);
  };

  const handleRawOutput = () => {
    if (fullResponse) {
      setShowFullResponse(!showFullResponse);
    }
  };

  const handleShowExecutionLogs = async () => {
    if (!currentRequestId) return;

    setLogType('Execution Log');
    setLogsLoading(true);
    setShowExecutionLogModal(false);

    const logs = await getExecutionLogs(currentRequestId, tenantId);

    if (logs && logs.logs) {
      setExecutionLogs(logs.logs);
      setSimplifiedExecutionLogs(utils.generateReadableDataFlow(logs.logs));
    } else {
      setExecutionLogs(`Logs not found for requestId: ${currentRequestId}`);
      setSimplifiedExecutionLogs('No execution logs available');
    }

    setLogsLoading(false);
    setShowExecutionLogModal(true);
  };

  const handleShowLLMLogs = async () => {
    if (!currentRequestId) return;

    setLogType('LLM Log');
    setLogsLoading(true);
    setShowLLMLogModal(false);

    const llMlogs = await getLLMLogs(currentRequestId, tenantId);
    if (llMlogs) {
      setLLMLogs(llMlogs?.logs);
    } else {
      setLLMLogs(`LLM Logs not found for requestId: ${currentRequestId}`);
    }
    setLogsLoading(false);
    setShowLLMLogModal(true);
  };

  const containerStyle = {
    position: 'fixed',
    top: `${position.y}px`,
    left: `${position.x}px`,
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    backgroundColor: '#1e1e1e',
    borderRadius: '8px',
    color: '#fff',
    width: '800px',
    maxHeight: '80vh',
    resize: 'both',
    overflow: 'auto',
    minWidth: '300px',
    minHeight: '200px',
    zIndex: 1000,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    backgroundColor: '#2d2d2d',
    border: '1px solid #444',
    borderRadius: '4px',
    color: '#fff',
    boxSizing: 'border-box',
    resize: 'vertical',
    minHeight: '60px',
    maxHeight: '200px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '1.5'
  };

  // const formStyle = {
  //   width: '100%',
  //   marginBottom: '20px'
  // };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#4ade80',
    border: 'none',
    borderRadius: '4px',
    color: 'black',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    // marginRight: '10px',
    width: 'max-content'
  };

  const closeButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#ef4444'
  };

  const outputStyle = {
    marginTop: '10px',
    padding: '15px',
    backgroundColor: 'white',
    borderRadius: '4px',
    // whiteSpace: 'pre-wrap',
    // wordWrap: 'break-word',
    transition: 'background-color 0.2s',
    maxHeight: '200px',
    overflowY: 'auto',
    color: 'black',
    ':hover': {
      backgroundColor: '#3d3d3d'
    }
  };

  const outputWrapper = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px'
  };

  const copyContentIcon = {
    cursor: 'pointer',
    alignSelf: 'flex-end',
    color: '#fff'
  };

  const fullResponseStyle = {
    ...outputStyle,
    marginTop: '20px',
    backgroundColor: '#1a1a1a',
    maxHeight: '200px',
    backgroundColor: 'white',
    color: 'black'
  };

  const preStyle = {
    // margin: 0,
    // padding: 0,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    backgroundColor: 'white',
    color: 'black',
    fontFamily: 'monospace',
    lineHeight: '1.5',
    fontSize: 16,
    fontStyle: 'normal',
    overflow: 'hidden',
    fontFamily: 'TT Commons',
    fontWeight: 400,
    lineHeight: '24px',
    color: 'black'
  };

  const errorStyle = {
    color: '#ef4444',
    marginTop: '10px'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: isDragging ? 'grabbing' : 'grab',
    userSelect: 'none'
  };

  // const modalStyles = {
  //   formGroup: {
  //     display: 'flex',
  //     flexDirection: 'row',
  //     gap: '4px'
  //   },
  //   label: {
  //     fontWeight: 'bold',
  //     marginTop: '4px'
  //   },
  //   input: {
  //     backgroundColor: '#333',
  //     color: '#e2e8f0',
  //     border: '1px solid #444',
  //     borderRadius: '4px',
  //     padding: '8px'
  //   }
  // };

  const handleSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'bookId' ? value.id : value.title
    }));
  };

  const modalStyles = {
    formGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '24px',
      flexWrap: 'wrap',
      width: '100%',
      marginTop: 15
    },
    inlineField: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flex: '1',
      width: '50%',
      justifyContent: 'space-between'
    },
    label: {
      fontWeight: '600',
      color: '#ffffff',
      whiteSpace: 'nowrap'
    },
    input: {
      backgroundColor: '#2d2d2d',
      color: '#e2e8f0',
      border: '1px solid #555',
      borderRadius: '6px',
      padding: '8px 10px',
      fontSize: '14px',
      height: '24px'
    },
    textarea: {
      backgroundColor: '#2d2d2d',
      color: '#e2e8f0',
      border: '1px solid #555',
      borderRadius: '6px',
      padding: '10px',
      fontSize: '14px',
      width: '97%',
      marginTop: '0.75rem'
    }
  };

  const formStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem'
  };

  const ReadMoreWrapper = styled.div({
    fontSize: 16,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    fontStyle: 'normal',
    overflow: 'hidden',
    fontFamily: 'TT Commons',
    fontWeight: 400,
    lineHeight: '24px',
    color: 'black',
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      fontSize: 16,
      fontStyle: 'normal',
      fontFamily: 'TT Commons',
      fontWeight: 700,
      lineHeight: '20px',
      color: 'black'
    },
    '& ul': {
      fontSize: 16,
      paddingInlineStart: 20,
      margin: 0,
      lineHeight: '24px',
      listStyleType: 'disc',
      whiteSpace: 'normal',
      '& li': {
        fontSize: 16,
        fontFamily: 'TT Commons',
        color: 'black',
        marginBottom: 5
      }
    },
    '& ol': {
      fontSize: 16,
      paddingInlineStart: 20,
      margin: 0,
      lineHeight: '24px',
      listStyleType: 'decimal',
      '& li': {
        fontSize: 16,
        fontFamily: 'TT Commons',
        color: 'black',
        marginBottom: 5,
        display: 'list-item'
      }
    },
    '& p': {
      lineHeight: '24px'
    },
    '& p:last-child': {
      marginBottom: 0
    },
    '& p:first-child': {
      marginTop: 0
    },
    '& a': {
      fontSize: 14,
      fontFamily: 'TT Commons',
      color: 'black',
      width: 16,
      height: 16,
      cursor: 'pointer',
      padding: 5,
      '&:hover': {
        textDecoration: 'none',
        color: '#4C406B',
        borderRadius: '50%',
        backgroundColor: '#D9D9D9'
      }
    },
    '& img': {
      width: '100%',
      marginTop: 10,
      cursor: 'pointer'
    },
    '& pre': {
      whiteSpace: 'normal'
    },
    '& table': {
      fontFamily: 'TT Commons',
      borderCollapse: 'collapse',
      width: '100%',
      marginTop: 10,
      marginBottom: 10,
      overflowX: 'auto'
    },
    '& td': {
      border: '1px solid #dddddd',
      textAlign: 'left',
      padding: 8,
      color: 'black'
    },
    '& th': {
      border: '1px solid #dddddd',
      textAlign: 'left',
      padding: 8,
      color: 'black'
    },
    '& tr:nth-child(even)': {
      backgroundColor: 'white'
    }
  });

  if (!isOpen) return null;

  return (
    <>
      <div
        style={overlayStyle}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      ></div>
      <div style={containerStyle}>
        <div style={headerStyle} onMouseDown={handleMouseDown}>
          <h2>Test Graph: {graphName}</h2>
          <button onClick={onClose} style={closeButtonStyle}>
            Close
          </button>
        </div>
        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={modalStyles.formGroup}>
            {/* <div style={modalStyles.inlineField}>
              <label htmlFor="productModel" style={modalStyles.label}>
                Product Model
              </label>
              <input
                type="text"
                name="productModel"
                id="productModel"
                value={formData.productModel || ''}
                onChange={handleChange}
                style={modalStyles.input}
              />
            </div> */}
            <div style={modalStyles.inlineField}>
              <label htmlFor="bookId" style={modalStyles.label}>
                Book ID
              </label>
              {/* <input
                type="text"
                name="bookId"
                id="bookId"
                value={formData.bookId || ''}
                onChange={handleChange}
                style={modalStyles.input}
              /> */}
              <Autocomplete
                options={bookList}
                name="bookId"
                idKey="bookId"
                onSelect={handleSelect}
                placeholder="Select Book Id..."
              />
            </div>
            <div style={modalStyles.inlineField}>
              <label htmlFor="productModel" style={modalStyles.label}>
                Product Model
              </label>
              <Autocomplete
                options={productModelList}
                name="productModel"
                onSelect={handleSelect}
                placeholder="Select Product Model..."
              />
            </div>
          </div>
          <div style={modalStyles.formGroup}>
            <div style={{ ...modalStyles.inlineField }}>
              <label htmlFor="pageId" style={modalStyles.label}>
                Page Id
              </label>
              <input
                type="text"
                name="pageId"
                id="pageId"
                value={formData.pageId || ''}
                onChange={handleChange}
                style={{ ...modalStyles.input, width: '220px' }}
              />
            </div>
            <div style={{ ...modalStyles.inlineField }}>
              <label htmlFor="imageObject" style={modalStyles.label}>
                Image Context
              </label>
              <input
                type="text"
                name="imageObject"
                id="imageObject"
                value={formData.imageObject || ''}
                onChange={handleChange}
                style={{ ...modalStyles.input, width: '220px' }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '15px' }}>
            <label htmlFor="input" style={modalStyles.label}>
              User Input
            </label>
            <textarea
              value={formData.input || ''}
              name="input"
              id="input"
              onChange={handleChange}
              placeholder="Enter your input..."
              style={modalStyles.textarea}
              disabled={loading}
              rows={3}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <button type="submit" style={buttonStyle} disabled={loading}>
              {loading ? 'Running...' : 'Run Graph'}
            </button>
            {isStreamDone && (
              <>
                <button type="button" onClick={handleShowExecutionLogs} style={buttonStyle} disabled={loading}>
                  {logsLoading && logType === 'Execution Log' ? 'Fetching Execution Logs...' : 'Show Execution Logs'}
                </button>
                <button type="button" onClick={handleShowLLMLogs} style={buttonStyle} disabled={loading}>
                  {logsLoading && logType === 'LLM Log' ? 'Fetching LLM Logs...' : 'Show LLM Logs'}
                </button>
                <button type="button" onClick={handleRawOutput} style={buttonStyle} disabled={loading}>
                  {!showFullResponse ? 'Show Raw Response' : 'Show Formatted Response'}
                </button>
              </>
            )}
            <button type="button" onClick={launchTestBed} style={buttonStyle} disabled={loading}>
              {'Run in Chatbot'}
            </button>
          </div>
        </form>

        {error && <div style={errorStyle}>{error}</div>}

        {output && !showFullResponse && (
          <div style={outputWrapper}>
            {isStreamDone && <CopyToClipboardButton valueToCopy={output} iconStyle={copyContentIcon} />}
            {/* <strong>Formatted Response:</strong> */}
            {/* <pre style={preStyle}>{output}</pre> */}
            {/* <div style={readMoreWrapper}>{checkMathJax(output)}</div> */}
            {/* <ReadMoreWrapper dangerouslySetInnerHTML={{ __html: output }}/>  */}
            {/* <span style={readMoreWrapper} dangerouslySetInnerHTML={{ __html: output }} /> */}
            {/* <Markdown options={{ wrapper: 'div', overrideStyles: preStyle }}>{output}</Markdown> */}
            <div style={outputStyle} ref={outputRef}>
              <ReadContent summaryData={output} />
              {goDeeperPills ? <GoDeeperPills pills={goDeeperPills} /> : null}
            </div>
          </div>
        )}

        {showFullResponse && fullResponse && (
          <div style={fullResponseStyle}>
            {/* <strong>Raw Response:</strong> */}
            <div style={preStyle}>{JSON.stringify(fullResponse, null, 2)}</div>
          </div>
        )}

        {showExecutionLogModal && (
          <LogsViewer
            isOpen={showExecutionLogModal}
            onClose={() => setShowExecutionLogModal(false)}
            jsonData={executionLogs}
            simplifiedLogs={simplifiedExecutionLogs}
            logType={logType}
          />
        )}
        {showLLMLogModal && (
          <LogsViewer
            isOpen={showLLMLogModal}
            logType={logType}
            onClose={() => setShowLLMLogModal(false)}
            jsonData={llmLogs}
          />
        )}
      </div>
    </>
  );
};

GraphTester.propTypes = {
  tenantState: shapes.modelOf(TenantsModel).isRequired
};

export default inject('tenantState')(observer(GraphTester));
